<template>
  <!-- 系统列表页 -->
  <div class="home" v-loading="!show">
    <TopHead ref="topHeadRef"></TopHead>

    <div v-if="show" class="content" ref="wrapRef">
      <div class="header" ref="headRef">
        <div class="head-mask"></div>
        <div class="head-content">
          <h2>{{user.name}}，您好</h2>
          <p>{{soupMsg}}</p>
        </div>
        <!-- <div class="download-box">
          <div class="code-box">
            <QrCode :codeUrl="downloadPage" class="qrCode"></QrCode>
          </div>
          <p class="tips">下载移动平台</p>
        </div> -->
      </div> 

      <el-row class="info-box" ref="middleRef">
        <!--流程列表-->
        <el-col :span="8">
          <Process ref="processRef"></Process>
        </el-col>
        <!--公告-->
        <el-col :span="8">
          <Notice @getImgUrl="setHistroyUrl"></Notice>
          <!-- @getImgUrl="setHistroyUrl" -->
        </el-col>
        <!--系统列表-->
        <el-col :span="8">
          <System></System>
        </el-col>
      </el-row>

      <Report ref="reportRef" v-if="false"></Report>
      <div class="histroy">
        <!-- <img src="../../assets/images/histroy.png" alt=""> -->
        <el-image :src="historyUrl" fit="cover"></el-image>
      </div>
    </div>
    
  </div>
</template>

<script>
import TopHead from './components/TopHead'
// import QrCode from './components/QrCode'
import Process from './components/Process'
import Notice from './components/Notice'
import System from './components/System'
import Report from './components/Report'
import { getChicken, getUserMessageApi, downloadPage } from '@/util/api'

export default {
  components: { TopHead, Process, Notice, System, Report},
  data() {
    return {
      downloadPage,
      soupMsg: '',
      sysList: [],
      user: {uid: '', name: ''},
      show: true,
      historyUrl: require('../../assets/images/histroy.png')
    };
  },
  watch:{
    "user.uid":{ //切换用户后、重新刷新界面
      handler(uid){
        if(uid){
          this.show = false;
          this.$nextTick(()=>{this.show = true});
        }
      }
    }
  },
  methods: {
    setHistroyUrl (data) {
      this.historyUrl = data.adImageUrl
    }
  },
  computed: { 
    _sysList() {
      const rows = [],
        _sysList = [...this.sysList];
      while (_sysList.length) {
        rows.push(_sysList.splice(0, 4));
      }
      return rows;
    }
  },
  created() {
    getUserMessageApi().then(res => {
      if (res.code === 0) {
        this.user = {
          name: res.data.name || "-",
          uid: res.data.uid || ''
        }
        this.$store.commit('setUser', this.user)
      } else {
        this.$message.warning(res.msg);
      }
    });

    getChicken().then(res => {
      if (res.code == 0) {
        this.soupMsg = res.data.content || ''
      }
    })
  },
  mounted() {
    // 监听浏览器变化，tabs下划线宽度、报表的变化
    this.$nextTick(()=> {
      window.onresize = () => {
        this.$refs.processRef.resetTabActivePosition(this.$refs.processRef.$refs.tabRef.$el)
        this.$refs.reportRef.getIframeStyle()
        this.$refs.reportRef.getReportHeight()
      }
    })
  }
};
</script>

<style scoped lang='less'>
@navHeight: 56px;
@manWrapHeight: 88px;
.home {
  .content {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 56px);
    // padding-bottom: 20px;
    background-color: #F0F2F5;
    .header{
      position: relative;
      margin-bottom: 10px;
      min-height: 140px;
      height: 17.5vh;
      background: url('../../assets/images/head_bg.jpg') center no-repeat;
      background-size: cover;
      box-shadow: 5px 0 9px 0 rgba(180,190,206,0.17);
      overflow: hidden;
      padding-left: 20px;
      .head-mask{
        position: absolute;
        top: 0;
        left: 0;
        min-height: 140px;
        height: 17.5vh;
        width: 100%;
        background: rgba(27, 55, 100, 0.24);
      }
      .head-content{
        position: absolute;
        top: 2vh;
        left: 20px;
        width: 24%;
        min-height: 130px;
        height: 16.25vh;
        background: rgba(4,6,11, 0.16);
        padding: 14px 22px;
        h2 {
          font-size: 18px;
          color: #FFFFFF;
          margin-bottom: 10px;
          font-weight: normal;
        }
        p{
          font-size: 14px;
          color: #FFFFFF;
          text-align: justify;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .download-box{
        position: absolute;
        right: 20px;
        top: 2vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1;
        .code-box{
          width: 72px;
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(27, 55, 100, 0.2);
          .qrCode{
            width: 50px;
            height: 50px;
            border: 4px solid #fff;
          }
        }
        .tips{
          margin-top: 10px;
          font-size: 12px;
          color: #FFFFFF;
        }
      }
    }
    .histroy{
      flex: 1;
      padding: 0 20px;
      overflow: hidden;
      min-height: 383px;
      /deep/ .el-image{
        width: 100%;
        height: 100%;
      }
      // img{
      //   width: 100%;
      //   height: 100%;
      //   margin: 0 auto;
      //   display: block;
      // }
    }
  }
  /deep/ .el-row {
    margin: 0 !important;
  }
}
</style>
